.a1{width:100%;}